<template>
<b-container fluid class="login-page pt-5">
    <b-col cols="12" lg="6" xl="4" offset-lg="3" offset-xl="4">
      <Notification v-bind.sync="notification" />
    </b-col>
    <div class="d-flex justify-content-center">
      <b-card class="mb-2 login-card rounded-0 shadow">
        <b-card-title class="d-flex justify-content py-3">
          Reset Password
        </b-card-title>
        <b-form>
          <b-form-group
            id="username_grp"
            label-for="email_input"
          >
            <InputField
              label="New Password"
              v-model="newPassword"
              :valid="sameConfirm"
              :options="{ ...defaultOptions, id: 'new_password'}"
            />
            <b-form-invalid-feedback id="username_feedback" class="mx-auto">
              Please provide your email.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="password_grp" label-for="password_input">
            <InputField
              label="Confirm Password"
              v-model="confirmPassword"
              :disabled="disabled.confirm"
              :valid="sameConfirm"
              :options="{ ...defaultOptions, id: 'confirm_password'}"
              @key:enter="changePassword"
            />
            <b-form-invalid-feedback id="password_feedback" class="mx-auto">
              Please provide your password.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-button-toolbar>
            <b-button
              v-if="googleLoginEnabled"
              :disabled="isLoadingPage"
              @click="onCLickLoginGoogle"
              variant="dark"
              class="ml-auto mr-1"
            >
              <v-icon
                name="brands/google"
                scale="1"
              />

            </b-button>
            <b-button
              :disabled="disabled.submit"
              @click="changePassword"
              variant="outline-dark"
              :class="{
                'mr-auto login-btn': googleLoginEnabled,
                'mx-auto login-btn': !googleLoginEnabled,
              }"
              >
              Submit
            </b-button>
          </b-button-toolbar>
        </b-form>
      </b-card>
    </div>
  </b-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Notification from '@/components/Notification';
import InputField from '@/components/InputField';
import AuthService from '@/services/AuthService';

export default {
  name: 'UserPassword',
  components: {
    InputField,
    Notification,
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      disabled: {
        new: true,
        confirm: true,
        submit: true,
      },
      sameConfirm: null,
      forgot_pass_key: '',
    };
  },
  watch: {
    newPassword() {
      if (this.newPassword.length > 0) {
        this.disabled.confirm = false;
        this.disabled.submit = true;
      } else {
        this.confirmPassword = '';
        this.disabled.confirm = true;
      }
    },
    confirmPassword() {
      if (this.newPassword === this.confirmPassword) {
        this.disabled.submit = false;
      } else {
        this.disabled.submit = true;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { key } = vm.$route.params;
      vm.forgot_pass_key = key;

      AuthService.validateForgotPasswordkey(key)
        .then((result) => {
          const { success, message } = result;

          if (!success) {
            const variant = success ? 'success' : 'danger';
            const notifOptions = { message, show: 10, variant };
            vm.$store.dispatch('setAlert', notifOptions);

            // vm.setNotification({
            //   show: true,
            //   dismissible: true,
            //   variant: 'danger',
            //   message: message || 'An error occurred',
            //   icon: { name: 'exclamation-triangle' },
            // });

            vm.$router.push({ name: 'login' });
          }
        });
    });
  },
  computed: {
    defaultOptions() {
      return {
        tagClass: 'col-12 col-sm-12 mb-2',
        labelClass: 'font-weight-bold mb-0',
        inputClass: 'form-control no-outline border-dark border-bottom rounded-0',
        type: 'password',
      };
    },
    ...mapGetters(['userData', 'initPassword']),
    ...mapState(['notification']),
  },
  methods: {
    changePassword() {
      this.startLoadingRequest();
      this.startLoadingPage();

      AuthService.forgotPasswordchange(this.forgot_pass_key, this.newPassword)
        .then((result) => {
          const { success, message } = result;
          this.stopLoadingRequest();
          this.stopLoadingPage();
          this.newPassword = '';
          this.confirmPassword = '';
          if (!success) {
            return this.setNotification({
              show: true,
              dismissible: true,
              variant: 'danger',
              message: message || 'An error occurred',
              icon: { name: 'exclamation-triangle' },
            });
          }

          const variant = success ? 'success' : 'danger';
          const notifOptions = { message, show: 10, variant };
          this.$store.dispatch('setAlert', notifOptions);
          return this.$router.push({ name: 'login' });

          // return this.setNotification({
          //   show: true,
          //   dismissible: true,
          //   variant: 'success',
          //   message: message || 'Password successfully changed!',
          //   icon: { name: 'exclamation-triangle' },
          // });
        });
    },
    resetForm() {
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
    },
    ...mapActions([
      'setNotification',
      'setPasswordDone',
      'resetAlert',
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
    ]),
  },
};
</script>
<style lang="scss" scoped>
.login-page {
  // padding-top: 30px;

  .login-card {
    max-width: 30rem;
    width: 100%;
  }

  .login-btn {
    max-width: 10em;
  }

  .forgot-pass {
    font-size: 1rem;
    margin-left: 30px;
  }

  #email,
  #password {
    &_input,
    &_feedback {
      max-width: 85%;
    }
  }
}
</style>
